module.exports = __webpack_public_path__ + "img/flyer-icon-6.65bfba08.svg";